module.exports = __webpack_public_path__ + "static/media/Packaging-Rocket-Distributors.91944e63.png";